import { render, staticRenderFns } from "./MovimentList.vue?vue&type=template&id=47dcf052&scoped=true&"
import script from "./MovimentList.vue?vue&type=script&lang=js&"
export * from "./MovimentList.vue?vue&type=script&lang=js&"
import style0 from "./MovimentList.vue?vue&type=style&index=0&id=47dcf052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dcf052",
  null
  
)

export default component.exports